import { type Theme } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles((theme: Theme) => ({
  container: {
    height: '100%',
  },
  topContainer: {
    display: 'flex',
    [theme.breakpoints.down(1100)]: {
      display: 'block',
    },
  },
  leftSection: {
    width: 'calc(100% - 380px)',
    paddingRight: '50px',
    [theme.breakpoints.down(1100)]: {
      width: '100%',
      paddingRight: 0,
    },
  },
  rightSection: {
    width: '380px',
    marginTop: '118px',
    [theme.breakpoints.down(1400)]: {
      marginTop: '55px',
    },
    [theme.breakpoints.down(1100)]: {
      display: 'flex',
      width: '100%',
      marginTop: 0,
      marginBottom: '45px',
    },
    [theme.breakpoints.down(600)]: {
      display: 'block',
    },
  },
  isNdaProject: {
    [theme.breakpoints.down(1100)]: {
      marginTop: '30px',
    },
  },
  middleContainer: {
    width: 'calc(100% - 380px)',
    paddingRight: '50px',
    [theme.breakpoints.down(1100)]: {
      width: '100%',
      paddingRight: 0,
    },
  },
}));
